import React, { useState, useEffect } from 'react';
import './Error.scss';

export interface ErrorProps {
  errorCode?: number;
}

export default function Error(props: ErrorProps) {
  const [errorCode, setErrorCode] = useState<string>();

  const getErrorCode = () => {
    const url = window.location.search;
    const code = url.replace(/\D/g, '');
    setErrorCode(code);
  };

  useEffect(() => {
    getErrorCode();
  }, []);

  return (
    <div className="error-wrapper">
      <div className="error-content">
        <div className="errorguy" />
        <div className="footer">
          {props.errorCode || errorCode === '404' ? (
            <div className="text">
              The page you have requested cannot be found.
              <br />
              Please check your URL to confirm it is typed correctly.
              <br />
              If you continue to have this issue, please contact support.
            </div>
          ) : (
            <div className="text">An unexpected error has occured</div>
          )}
        </div>
      </div>
    </div>
  );
}
